export default __webpack_public_path__ + "static/media/cert-customer-cpttm.3a48c27f.jpg";